import React from "react";
import moment from "moment";
import { useTranslation } from "@helpers/translate";
import BinifyLogo from "@components/library/Icons/BinifyLogo";
import config from "../../../../config";
import "./FooterLanding.sass";

const LEGAL_LINKS = {
  privacyPolicy: "/docs/legal/privacy-policy.pdf",
  termsOfUse: "/docs/legal/terms-of-use.pdf",
  kycAmlPolicy: "/docs/legal/aml-policy.pdf",
  cookiePolicy: "/docs/legal/cookie-policy.pdf",
};

const FooterLink = ({ href, children, className = "" }) => (
  <a
    href={href}
    className={`landing-footer__link ${className}`.trim()}
    target="_blank"
    rel="noopener noreferrer"
  >
    <span className="landing-footer__link-text text-storm-gray">
      {children}
    </span>
  </a>
);

const MobileContact = ({ title, email }) => (
  <div className="landing-footer__mobile-contact">
    <p className="landing-footer__mobile-contact-text text-storm-gray">
      {title}{" "}
      <a
        href={`mailto:${email}`}
        className="landing-footer__mobile-contact-link text-shark"
      >
        {email}
      </a>
    </p>
  </div>
);

export const FooterLanding = () => {
  const { __ } = useTranslation();

  return (
    <footer className="landing-footer padding-container">
      <div className="landing-footer__desktop">
        <div className="landing-footer__desktop-content">
          <div className="landing-footer__desktop-left">
            <p className="text-storm-gray">{__("seo.title")} {moment().year()}. {__("main.footer.rights")}</p>
          </div>

          <div className="landing-footer__desktop-center">
            <p className="landing-footer__desktop-center-text text-storm-gray">
              {__("main.footer.generalInfo")}{" "}
              <a
                href={`mailto:${config.infoEmail}`}
                className="landing-footer__desktop-center-link text-shark"
              >
                {config.infoEmail}
              </a>
            </p>
            <p className="landing-footer__desktop-center-text-margin text-storm-gray">
              {__("main.footer.technicalSupport")}{" "}
              <a
                href={`mailto:${config.supportEmail}`}
                className="landing-footer__desktop-center-link text-shark"
              >
                {config.supportEmail}
              </a>
            </p>
          </div>

          <div className="landing-footer__desktop-right">
            <FooterLink href={LEGAL_LINKS.privacyPolicy}>
              {__("main.footer.privacyPolicy")}
            </FooterLink>
            <FooterLink href={LEGAL_LINKS.termsOfUse}>
              {__("main.footer.termsOfUse")}
            </FooterLink>
            <FooterLink href={LEGAL_LINKS.kycAmlPolicy}>
              {__("main.footer.kycAmlPolicy")}
            </FooterLink>
            <FooterLink href={LEGAL_LINKS.cookiePolicy}>
              {__("main.footer.cookiePolicy")}
            </FooterLink>
          </div>
        </div>
        <div className="landing-footer__desktop-logo">
          <BinifyLogo width={"1164"} height={"214.42"} />
        </div>
      </div>

      <div className="landing-footer__mobile">
        <div className="landing-footer__mobile-links">
          <FooterLink
            href={LEGAL_LINKS.privacyPolicy}
            className="landing-footer__mobile-link-left"
          >
            {__("main.footer.privacyPolicy")}
          </FooterLink>
          <FooterLink
            href={LEGAL_LINKS.termsOfUse}
            className="landing-footer__mobile-link-right"
          >
            {__("main.footer.termsOfUse")}
          </FooterLink>
          <FooterLink
            href={LEGAL_LINKS.kycAmlPolicy}
            className="landing-footer__mobile-link-left"
          >
            {__("main.footer.kycAmlPolicy")}
          </FooterLink>
          <FooterLink
            href={LEGAL_LINKS.cookiePolicy}
            className="landing-footer__mobile-link-right"
          >
            {__("main.footer.cookiePolicy")}
          </FooterLink>
        </div>

        <div className="landing-footer__mobile-logo">
          <BinifyLogo width={"408"} height={"75"} />
        </div>

        <div className="landing-footer__mobile-contacts">
          <MobileContact
            title={__("main.footer.information")}
            email={config.infoEmail}
          />
          <MobileContact
            title={__("main.footer.support")}
            email={config.supportEmail}
          />
        </div>
      </div>
    </footer>
  );
};
